module.exports = __webpack_public_path__ + "static/media/wifi-level-0.b40ed257.svg";